import React from 'react';

import Routes from './routes/Routes';
import { BrowserRouter as Router } from 'react-router-dom';
import { ProductColorProvider } from './utils/productColorContext';

export default function App() {
  return (
    <ProductColorProvider>
      <Router basename={process.env.PUBLIC_URL}>
        <Routes />
      </Router>
    </ProductColorProvider>
  );
}
